export const OB_TASKS = [
  {
    shift: "07.00 – 16.00",
    tasks: [
      {
        id: 1,
        title: "MEMBERSIHKAN AREA SCO (ATAS & BAWAH) DAN GA",
        subTasks: [
          { id: 1, title: "Membersihkan Area SCO Atas" },
          { id: 2, title: "Membersihkan Area SCO Bawah Pagi" },
          { id: 3, title: "Membersihkan Area SCO Bawah Siang" },
          { id: 4, title: "Membersihkan Area GA" }
        ]
      },
      {
        id: 2,
        title: "MEMBERSIHKAN AREA OFFICE",
        subTasks: [
          { id: 5, title: "Membersihkan Area Office" },
          { id: 6, title: "Membersihkan Kamar Mandi" },
          // { id: 6, title: "Membersihkan Mushola, Wastafel & Kitchenset" },
        ]
      },
      {
        id: 3,
        title: "MEMBERSIHKAN AREA HALAMAN DEPAN DAN SAMPING",
        subTasks: [
          { id: 7, title: "Membersihkan Area Halaman Depan" },
          { id: 8, title: "Membersihkan Area Halaman Samping" },
          // { id: 9, title: "Membersihkan Area Taman" },
        ]
      },
      {
        id: 4,
        title: "MEMBERSIHKAN AREA OUTBOUND DAN RUANG TRANSIT",
        subTasks: [
          { id: 10, title: "Membersihkan Area Outbound" },
          { id: 11, title: "Membersihkan Area Transit" },
        ]
      },
      {
        id: 10,
        title: "TUGAS TAMBAHAN",
        subTasks: []
      }
    ]
  },
  {
    shift: "08.00 – 17.00",
    tasks: [
      {
        id: 5,
        title: "MEMBERSIHKAN AREA INBOUND AREA KURIR DAN UNDEL",
        subTasks: [
          // { id: 12, title: "Membersihkan Area Kurir" },
          { id: 13, title: "Membersihkan Area Undel" },
          { id: 14, title: "Membersihkan Area Inbound" },
        ]
      },
      {
        id: 6,
        title: "MEMBERSIHKAN AREA RUANG ADMIN, PACKING KAYU DAN HALAMAN TENGAH, & TAMAN",
        subTasks: [
          { id: 15, title: "Membersihkan Area Ruang Admin & Ruang Tunggu Supir" },
          { id: 16, title: "Membersihkan Area Parkiran & Halaman" },
          // { id: 17, title: "Membersihkan Area Packing Kayu" },
          { id: 18, title: "Membersihkan Area Taman" }
        ]
      },
      {
        id: 8,
        title: "MEBERSIHKAN KAMAR MANDI DAN MASJID",
        subTasks: [
          { id: 19, title: "Membersihkan Area Kamar Mandi" },
          { id: 20, title: "Membersihkan Area Masjid" },
        ]
      },
      {
        id: 9,
        title: "MERAWAT KANDANG DAN MEMBERI MAKAN HEWAN",
        subTasks: [
          { id: 21, title: "Membersihkan & Memberi Makan Hewan Pagi" },
          { id: 22, title: "Membersihkan & Memberi Makan Hewan Sore" }
        ]
      },
      {
        id: 11,
        title: "TUGAS TAMBAHAN",
        subTasks: []
      }
    ]
  }
];
